import { render, staticRenderFns } from "./product-technical-information.vue?vue&type=template&id=b828c89e&"
import script from "./product-technical-information.vue?vue&type=script&lang=js&"
export * from "./product-technical-information.vue?vue&type=script&lang=js&"
import style0 from "./product-technical-information.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports